<kendo-dialog *ngIf="active" (close)="closeForm()" [width]="700" [height]="480">
    <kendo-dialog-titlebar>
        Message Details
    </kendo-dialog-titlebar>

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-4">
                <span>Id:</span>
            </div>   
            <div class="col-sm-8">
                <span>{{model?.Id}}</span>
            </div>           
        </div>
        <div class="row">
            <div class="col-sm-4">
                <span>Sequence Nbr:</span>
            </div>   
            <div class="col-sm-8">
                <span>{{model?.SequenceNumber}}</span>
            </div>           
        </div>
        <div class="row">
            <div class="col-sm-4">
                <span>Enqueued At:</span>
            </div>   
            <div class="col-sm-8">
                <span>{{model?.EnqueuedAt | date:'short'}}</span>
            </div>           
        </div>
        <div class="row">
            <div class="col-sm-4">
                <span>Size (Bytes):</span>
            </div>   
            <div class="col-sm-8">
                <span>{{model?.Size}}</span>
            </div>           
        </div> 
        <form novalidate [formGroup]="editForm">
            <div class="row">
                <div class="col-sm-4">
                    <span>Body:</span>
                </div>  
                <div class="col-sm-8">
                    <textarea kendoTextArea cols="50" rows="4" formControlName="Body"></textarea>
                </div>                                 
            </div>             
        </form> 
        <div class="row">
            <div class="col-sm-12">
                <kendo-panelbar>
                    <kendo-panelbar-item [title]="'Custom Properties'">
                        <ng-template kendoPanelBarContent>
                            <kendo-grid
                                #grid
                                [data]="gridItems | async"
                                [style.height]="200"
                                [pageable]="false"  
                                [pageSize]="gridState.take"
                                [skip]="gridState.skip"
                                [sort]="gridState.sort"
                                [sortable]="false"
                                [navigable]="false"
                                [loading]="false"
                                [resizable]="false">
        
                                <kendo-grid-column
                                    field="Name"
                                    title="Name"
                                    width="35%">
                                </kendo-grid-column>
            
                                <kendo-grid-column
                                    field="Value"
                                    title="Value"
                                    width="65%">
                                </kendo-grid-column>
                            </kendo-grid>                          
                        </ng-template>
                    </kendo-panelbar-item>
                </kendo-panelbar>
            </div>             
        </div>      
    </div>

    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">Cancel</button>
        <button class="k-button btn-danger" [disabled]="scope == 1 || scope == 2" (click)="onDelete($event)">Delete</button>
        <button class="k-button k-primary" [hidden]="scope == 1 || scope == 2" (click)="onResubmit($event)">Resubmit</button>
    </kendo-dialog-actions>
</kendo-dialog>

<div kendoDialogContainer></div>
